import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Container,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { type ChangeEvent, useState } from "react";
import { useAppDispatch } from "../../../hooks/reduxHooks";
import {
    useCustomerDataContext,
    ViewMode,
} from "../context/CustomerDataContext";

export default function Start() {
    const { viewMode, setViewMode } = useCustomerDataContext();

    const handleCheckData = async () => {
        setViewMode(ViewMode.Survey);
    };

    return (
        <Container
            sx={{ pt: 5, mb: 10 }}
            maxWidth="md"
        >
            <Stack gap={2}>
                <Typography
                    component="h3"
                    fontSize="large"
                >
                    یک مسیر ساده اما حرفه‌ای برای فروشنده‌های حرفه‌ای صنعت
                    ساختمان
                </Typography>
                <Typography component="p">
                    به راهنمای ساده شده‌ی نقشه‌ی راه فروش به سازندگان خوش آمدید.
                    طی ۳ دقیقه‌ی آینده و با چند کلیک، به راهنمای ساده اما
                    کاربردی و حرفه‌ای خواهید رسید که با کمک آن می‌توانید فروش
                    خود را متحول کنید. آماده‌ی تغییر، رشد و تسلط بر بازار هستید؟
                </Typography>

                <img
                    style={{ margin: "auto" }}
                    width={300}
                    src="/images/ps_roadmap.png"
                    alt="roadmap"
                />

                <Button
                    sx={{ width: "fit-content", m: "auto" }}
                    fullWidth={false}
                    variant="contained"
                    color="primary"
                    size="large"
                    id="start-button"
                    onClick={handleCheckData}
                >
                    شروع مسیر ارزیابی
                </Button>
            </Stack>
        </Container>
    );
}
